import { Button, Icon, Loader } from "@screencloud/screencloud-ui-components";
import { FormattedMessage } from "react-intl";
import {
  NoChangeContainer,
  NoChangeDescription,
  NoChangeTitle,
  StateContainer,
  StateDescription,
  StateTitle,
} from "./styles";

export const CompareLoadingState = () => (
  <StateContainer data-testid="compare-changes-loading">
    <Loader active inline="centered" />
    <StateDescription>
      <FormattedMessage
        id="compare_changes.loading"
        defaultMessage="Loading comparison…"
      />
    </StateDescription>
  </StateContainer>
);

export interface CompareErrorStateProps {
  onRetry?: () => void;
}

export const CompareErrorState = ({ onRetry }: CompareErrorStateProps) => (
  <StateContainer data-testid="compare-changes-error">
    <Icon name="warning" />
    <StateTitle>
      <FormattedMessage
        id="compare_changes.error.title"
        defaultMessage="Something went wrong"
      />
    </StateTitle>
    <StateDescription>
      <FormattedMessage
        id="compare_changes.error.description"
        defaultMessage="We couldn't load the comparison."
      />
    </StateDescription>
    {onRetry && (
      <Button data-testid="compare-changes-retry" onClick={onRetry}>
        <FormattedMessage
          id="compare_changes.error.retry"
          defaultMessage="Try Again"
        />
      </Button>
    )}
  </StateContainer>
);

export const CompareNoChangeState = () => (
  <NoChangeContainer data-testid="compare-changes-no-change">
    <Icon name="checked-circle" />
    <NoChangeTitle>
      <FormattedMessage
        id="compare_changes.no_changes.title"
        defaultMessage="There are no changes to review"
      />
    </NoChangeTitle>
    <NoChangeDescription>
      <FormattedMessage
        id="compare_changes.no_changes.description"
        defaultMessage="Someone else might have published just right now."
      />
    </NoChangeDescription>
  </NoChangeContainer>
);
